import React from 'react';
import {FormGroup, Label, Input} from "reactstrap";
import { useTranslation } from 'react-i18next';

const AppInput = ({label, name, value, required = false, error = null, touched = false, onChange = () => null, onBlur = () => null, type = 'text', placeholder = 'Saisissez...', ...props}) => {
    const { t } = useTranslation();
    return (
        <FormGroup className="text-left">
            {label && (<Label
                    htmlFor={name}
                    className="control-label">
                    {typeof label === 'string' ? t(label) : label}
                </Label>)} {required && <span className="text-danger">*</span>}
            <Input
                type={type}
                name={name}
                className="form-control"
                id={name}
                value={value}
                placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder}
                onChange={onChange}
                onBlur={onBlur}
                {...props}
            />
            {error && touched && (
                <em className="text-danger font-small italic font-weight-bold">{typeof error === 'string' ? t(error) : error}</em>
            )}
        </FormGroup>
    );
}

export default AppInput;